export const GLOBAL_STATE = 'Chat'

export const CHAT_MESSAGE_LIST = 'CHAT_MESSAGE_LIST' as const
export const CHAT_MESSAGE_POST = 'CHAT_MESSAGE_POST' as const
export const CHAT_MESSAGE_ALL = 'CHAT_MESSAGE_ALL' as const
